/**
 * @generated SignedSource<<81932ad9df8af9ad7b90203537e06ad7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "visibility": 2
      }
    }
  ],
  "concreteType": "VppTsConnection",
  "kind": "LinkedField",
  "name": "allVppTs",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": "allVppTs(condition:{\"visibility\":2})"
},
v3 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "VppRtsConnection",
  "kind": "LinkedField",
  "name": "vppRTsByPartnerId",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PartnerProgramsContainerQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PartnerProgramsContainerQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d44ad2adfc454aa6532a77c831cfe78e",
    "id": null,
    "metadata": {},
    "name": "PartnerProgramsContainerQuery",
    "operationKind": "query",
    "text": "query PartnerProgramsContainerQuery(\n  $accountId: UUID!\n) {\n  allVppTs(condition: {visibility: 2}) {\n    totalCount\n  }\n  accountTByAccountId(accountId: $accountId) {\n    vppRTsByPartnerId {\n      totalCount\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "c1153a50087e94212fd49c717db3d31a";

module.exports = node;
